import { render } from "./suspended-comp.vue?vue&type=template&id=107b0e82&scoped=true"
import script from "./suspended-comp.vue?vue&type=script&lang=js"
export * from "./suspended-comp.vue?vue&type=script&lang=js"

import "./suspended-comp.vue?vue&type=style&index=0&id=107b0e82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107b0e82"]])

export default __exports__